export default {
  htmlContent:'',
  message:''
};
